import { AlertServiceProvider } from '../../../core/services/alert-service/alert-service';
import { Component, OnInit } from '@angular/core';
import { FormField } from '../../../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-field.interface';
import { FormGroup } from '@angular/forms';
import {IonicPage, ModalController, NavParams, PopoverController, ToastController, ViewController} from 'ionic-angular';
import { take } from 'rxjs/operators';
import { TextServiceProvider } from '../../../core/services/text-service/text-service';
import { UserTask } from '../../interfaces/user-task.interface';
import { UserTaskService } from '../../services/user-task.service/user-task.service';
import { ENVIRONMENT } from '../../../../../environments/environment';
import {UserTaskInfoPage} from "./info/user-task-info";
import FormVariablesUtils
  from "../../../../submodules/sellions_forms/projects/forms/src/lib/utils/form-variables-utils";
import { isString } from "../../../../shared/pipes/helpers/helpers";

@IonicPage()
@Component({
  selector: 'page-user-task-preview',
  templateUrl: 'user-task-preview.html',
})
export class UserTaskPreviewPage implements OnInit {
  public disabled: boolean;
  public userTask: UserTask;
  public dataViewBaseAPI = ENVIRONMENT.engineUrl;
  public form: FormField[];
  public json: any;
  public taskType;
  public valid: boolean = false;
  public assignButtonAvailable: any;

  constructor(
    public textService: TextServiceProvider,
    private alertService: AlertServiceProvider,
    private navParams: NavParams,
    private userTaskService: UserTaskService,
    private viewCtrl: ViewController,
    private modalCtrl: ModalController,
    private popoverCtrl: PopoverController,
    private toastController: ToastController
  ) {
    this.userTask = this.navParams.get('userTask');
    this.taskType = this.navParams.get('taskType');
    this.disabled = this.navParams.get('disabled');
    this.assignButtonAvailable = this.navParams.get('assignButtonAvailable');
  }

  public ngOnInit() {
    this.getUserTask(this.userTask.number);
  }

  public formChangeUpdate(form: FormGroup) {
    this.json = form.getRawValue();
    this.valid = form.valid;
  }

  public getUserTask(id: string) {
    this.userTaskService
      .get(id)
      .pipe(take(1))
      .subscribe((userTask: UserTask) => {
        this.userTask = userTask;
        this.form = this.getForm(userTask);
      });
  }

  private getForm(task: UserTask): FormField[] {
    const form = JSON.parse(this.userTask.form) as FormField[];
    return form.map((field) => ({ ...field, predefinedValue: task.variables && task.variables[field.id] }));
  }

  public save() {
    this.disabled = true;
    const formVariables = FormVariablesUtils.getFormVariables(this.json)
    this.userTaskService
      .complete(this.userTask.number, formVariables)
      .pipe(take(1))
      .subscribe(
        () => {
          this.showSuccessToast('Pomyślnie zapisano zadanie');
          this.close();
        },
        (error) => {
          this.alertService.showErrorAlert('Niestety nie udało się zrealizować zadania. ' + (error.error.errorMessage ? error.error.errorMessage : isString(error.error) ? error.error : 'Wystąpił nieznany błąd.' ), 'Bląd');
          this.disabled = false;
        },
      );
  }

  private showSuccessToast(message: string) {
    this.toastController.create({
      message: message,
      position: 'top',
      duration: 5000
    }).present();
  }

  public assign() {
    this.userTaskService
      .claim(this.userTask.number)
      .pipe(take(1))
      .subscribe(
        () => {
          this.showSuccessToast('Pomyślnie przypisano zadanie');
          this.close();
        },
        (error) => this.alertService.showErrorAlert('Niestety nie udało się przypisać zadania. ' + error.error, 'Bląd'),
      );
  }

  async openUserTaskInfo() {
    const modal = this.popoverCtrl.create(UserTaskInfoPage, {
      userTask: this.userTask,
      taskType: this.taskType
    }, {cssClass: 'user-task-preview'});
    modal.present();
  }

  public close() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-task-preview/user-task-preview.ts